import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Alert, Autocomplete, Button, TextField } from "@mui/material";
import { impairInvestment } from "../../actions/impairment";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

import Typography from "@mui/material/Typography";

import { useDispatch, useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import toast from "react-hot-toast";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "25px",
  transform: "translate(-50%, -50%)",
  width: 700,
  // height: 500,
  bgcolor: "white",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const columns = [
  { id: "code", label: "Code", minWidth: 100 },
  { id: "investment_type", label: "Investment type", minWidth: 200 },
  {
    id: "regulator",
    label: "Regulator",
    minWidth: 170,
    align: "right",
  },
  {
    id: "cost",
    label: "Cost",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "rate",
    label: "Rate",
    minWidth: 170,
    align: "right",
  },
  {
    id: "impaired_amount",
    label: "Impaired Amount",
    minWidth: 170,
    align: "right",
  },
  {
    id: "impairment_date",
    label: "Impairment date",
    minWidth: 170,
    align: "right",
  },
  {
    id: "maturity_date",
    label: "Maturity date",
    minWidth: 170,
    align: "right",
  },
];
function createData(
  id,
  code,
  investment_type,
  regulator,
  cost,
  rate,
  impaired_amount,
  impairment_date,
  maturity_date
) {
  return {
    id,
    code,
    investment_type,
    regulator,
    cost,
    rate,
    impaired_amount,
    impairment_date,
    maturity_date,
  };
}
export default function Impairment() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const impaired = useSelector((state) => state.impaired);
  const [data, setData] = React.useState(impaired.data);

  React.useState(() => {
    setData(impaired.data);
  }, [impaired.data]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const investments = useSelector((state) => state.investments);
  const undefinedInvestments = useSelector(
    (state) => state.approvedUndefinedInvestments
  );
  const allInvestments = [...investments, ...undefinedInvestments];

  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  let [investmentData, setInvestmentData] = React.useState({
    code: "",
    impaired_amount: "",
    impairment_date: "",
    impaired: "true",
    impaired_by: user.results.firstName + " " + user.results.lastName,
  });

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const dispatch = useDispatch();
  const rows = data.map((data) =>
    createData(
      data._id,
      data.code,
      data.investment_type,
      data.regulator,
      data.cost,
      data.rate,
      data.impaired_amount,
      moment(data.impairment_date).format("DD-MM-YYYY"),
      moment(data.maturity_date).format("DD-MM-YYYY")
    )
  );
  let options = [];
  allInvestments?.map((data) => options.push(data.code));
  const neededData = allInvestments.filter(
    (data) => data.code === investmentData.code
  );
  const id = neededData.length > 0 ? neededData[0]._id : "";
  function impair() {
    if (
      investmentData.code &&
      investmentData.impaired_amount &&
      investmentData.impairment_date &&
      id
    ) {
      dispatch(impairInvestment(id, investmentData));
      handleClose();
      setInvestmentData({
        ...investmentData,
        code: "",
        impairment_amount: "",
        impairment_date: "",
      });
    } else {
      toast.error("Please fill in required fields");
    }
  }

  return (
    <div>
      <Paper sx={{ width: "100%" }}>
        <Modal
          aria-labelledby='transition-modal-title'
          aria-describedby='transition-modal-description'
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}>
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id='transition-modal-title'
                variant='h5'
                component='h2'
                style={{ marginBottom: "15px" }}>
                Impair Investment
              </Typography>
              <form
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "20px",
                  justifyContent: "space-around",
                }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Autocomplete
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    disablePortal
                    id='combo-box-demo'
                    options={options}
                    onChange={(e, n) =>
                      setInvestmentData({ ...investmentData, code: n })
                    }
                    sx={{ width: 300 }}
                    renderInput={(params) => (
                      <TextField {...params} label='Code' required />
                    )}
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type='number'
                    size='small'
                    label='Amount'
                    required
                    value={investmentData.impaired_amount}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        impaired_amount: e.target.value,
                      })
                    }
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type='date'
                    size='small'
                    label='impairment Date'
                    value={investmentData.impairment_date}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        impairment_date: e.target.value,
                      })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />

                  <div>
                    <Button
                      onClick={impair}
                      variant='contained'
                      size='small'
                      style={{
                        textTransform: "none",
                        margin: "5px",
                      }}>
                      Submit
                    </Button>
                    <Button
                      variant='contained'
                      style={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                      }}
                      onClick={handleClose}
                      size='small'>
                      Cancel
                    </Button>
                  </div>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}>
          <Button
            size='small'
            style={{
              textTransform: "capitalize",
              margin: "5px",
            }}
            onClick={handleOpen}
            variant='contained'>
            Impair Investment
          </Button>
        </div>
        {impaired.error && <Alert severity='error'>{impaired.error}</Alert>}
        {impaired.success && (
          <Alert severity='success'>{impaired.success}</Alert>
        )}

        <TableContainer sx={{ maxHeight: 740 }}>
          <Table size='small' stickyHeader aria-label='sticky table'>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#f8f8f8",
                      color: "#000",
                      fontWeight: "bold",
                    }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
